import { apiPath } from "./common";
import { webApiRoot } from "../global";
import { resetLMS } from "../redux/slices/LMS.slice";
import { logoutAction, storeAuthToken, storeLoginToken } from "../redux/slices/authSlice";

let refreshingPromise: Promise<string | null> | null = null;

export async function fetchRefreshToken(store: any) {
  // ✅ If already refreshing, return the same promise to all callers
  if (refreshingPromise) return refreshingPromise;

  const state = store.getState();
  const refreshToken = state.authSlice.refreshToken;

  refreshingPromise = new Promise((resolve, reject) => {
    fetch(`${webApiRoot}${apiPath.REFRESH_TOKEN}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Refresh failed");
        return response.json();
      })
      .then((data) => {
        const newAccessToken = data.token;
        store.dispatch(storeLoginToken(newAccessToken));
        store.dispatch(storeAuthToken({ ...data?.data }));
        resolve(newAccessToken);
      })
      .catch((error) => {
        store.dispatch(logoutAction(""));
        store.dispatch(resetLMS(""));
        reject(error);
      })
      .finally(() => {
        refreshingPromise = null;
      });
  });

  return refreshingPromise;
}
